export enum AiResponseType {
  EXPRESSION = "EXPRESSION",
  CLARIFICATION = "CLARIFICATION",
  DECLINE = "DECLINE",
}

export enum ClarificationMode {
  CONFIRMATION = "CONFIRMATION",
  SELECTION = "SELECTION",
  MULTI_SELECTION = "MULTI_SELECTION",
}

export enum AiFeedbackRating {
  POSITIVE = "POSITIVE",
  NEGATIVE = "NEGATIVE",
}
